/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterCreator_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectSearch_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilterCreator_itemSearch";
};
export type SbSharedRefineMenuFilterCreator_itemSearch$data = SbSharedRefineMenuFilterCreator_itemSearch;
export type SbSharedRefineMenuFilterCreator_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterCreator_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterCreator_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterCreator_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'a5e1f31635dce59cd808ba4f0162a697';
export default node;
